import(/* webpackMode: "eager" */ "/ui/src/screens/ProjectDetailScreen/index.jsx")